/**
 * Marks DOM nodes where ad inventory is expected (same spots as the AdSenseAd component).
 * Raptive dashboard selectors can target `[data-priceme-ad-placement]` if useful.
 */
export const PRICEME_AD_PLACEMENT_ATTR = "data-priceme-ad-placement";
export const PRICEME_AD_TYPE_ATTR = "data-priceme-ad-type";

export const pricemeAdPlacementSelector = `[${PRICEME_AD_PLACEMENT_ATTR}]`;
export const pricemeAdPlacementTypeSelector = (placementType: PricemeAdPlacementType): string =>
    `[${PRICEME_AD_PLACEMENT_ATTR}][${PRICEME_AD_TYPE_ATTR}="${placementType}"]`;

export type PricemeAdPlacementType = "header" | "content" | "sticky-sidebar" | "outstream-video" | "sticky-footer";
